import { Box, Button, Card, Flex, Grid, GridItem, Heading,Text,Input} from '@chakra-ui/react';
import { BsPlusLg as PlusIcon } from "react-icons/bs";
import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
import {TopLink} from '../';
import apiCall from '../../../../utils/apiCall';
import { Formik,Form,Field } from "formik";
import { useAtom } from 'jotai';
import * as Yup from 'yup';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
// import { GrCloudUpload as UpIcon} from "react-icons/gr";
import { useState,useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import ReactPaginate from 'react-paginate';
import styled from '@emotion/styled';
import { Loader } from '../../../../customs';



const src=`/public-assets/upload_icon.png`;
type DocumentDataType ={
  Id:number,
  DocumentTypeName:string,
  Date?:string
}


const list: DocumentDataType [] = [
  {
    Id:1,
    DocumentTypeName:'Study Pack',
    Date:'11-04-23'
  },
  {
    Id:2,
    DocumentTypeName:'Study Pack',
    Date:'11-04-23'
  },
  {
    Id:3,
    DocumentTypeName:'Past Question',
    Date:'11-04-23'
  },
  {
    Id:4,
    DocumentTypeName:'Syllabus',
    Date:'11-04-23'
  },
  {
    Id:5,
    DocumentTypeName:'Study Center',
    Date:'11-04-23'
  },
  {
    Id:5,
    DocumentTypeName:'Study Center',
    Date:'11-04-23'
  },
  {
    Id:4,
    DocumentTypeName:'Syllabus',
    Date:'11-04-23'
  },
  {
    Id:3,
    DocumentTypeName:'Past Question',
    Date:'11-04-23'
  },
]

const report_icon = '/svg/uploadIcon.png';

const DocumentType = () => {
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const queryClient = useQueryClient();
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const {data:AllExamDocumentType,isLoading} = useQuery(['exam-document-type'],{
    queryFn: async () => await apiCall().get(`/exam/setup/examDocumentType`),
    select(data){
      return data.data.Data;
    }
  })
  const [filter_data,set_filter_data] = useState<any>(AllExamDocumentType);
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
   useEffect(()=>{
    set_filter_data(AllExamDocumentType)
  },[AllExamDocumentType])



  const {mutate:deleteDocument,isLoading:isLoadingDelete} = useMutation({
    mutationKey:['delete-exam-document-type'],
    mutationFn:async (Id:number)=> {
      return await apiCall().get(`/exam/setup/examDocumentType/${Id}/delete`)
    },
    onSuccess(data:any){
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Added Successfully'
      })
      set_Nopen(true);
      queryClient.invalidateQueries({
        queryKey:['exam-document-type']
      })
    },
    onError(error:any, variables, context) {
      set_notification({
        type:'error',
        message:error?.data?.Message || 'Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }

  } )
  const handleAddExamDocumentType = () =>{
    set_modal({
      header:'Add Document Type',
      content:<AddType />
    })
    set_open(true);
  }
  const handleDeleteDocument = (Id:number) =>{
    set_modal({
      header:'Delete Document',
      content:<Flex  flexDir="column" gap="20px">
        <Text>
          Are you sure you want to delete this document
        </Text>
        <Flex p="10px 0" justify="space-between" align="center">
          <Button onClick={()=>set_open(false)} variant="outline" borderColor={'var(--dark-green-color'} 
            color="var(--dark-green-color)" >Cancel</Button>
          <Button onClick={()=>deleteDocument(Id)} bg="var(--dark-green-color)" color="var(--white-color)">{isLoadingDelete?'Loading':'Delete'}</Button>
        </Flex>

      </Flex>
    })
    set_open(true);
  }

  const handleEdit = (data:any) =>{
    set_modal({
      header:'Edit Document',
      content:<AddType {...data} />
    })
    set_open(true);
  }

  return (
    <>
    {isLoading?<Loader />:
     <Box>
      <TopLink />
      <Flex justify="space-between" align="center" mt="20px">
        <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">Document Type SetUp</Heading>
        <Button onClick={handleAddExamDocumentType}  bg="var(--dark-green-color)" color="var(--white-color)"colorScheme='green' leftIcon={<PlusIcon />}>Add Document Type</Button>
      </Flex>
      <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Document Types</Heading>
            <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
      <Grid templateColumns={'repeat(2,.8fr)'} gap="20px" mt="20px">

       {AllExamDocumentType && AllExamDocumentType.length > 0 ? AllExamDocumentType.map((eDoc:any) => 
       <Card key={eDoc?.Id} as ={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row" >
           <Flex flexDir="column" gap="3px">
          <Text m="3" fontWeight="bold">
            Document Name: <Box as="span" fontWeight="normal">{eDoc?.DocumentTypeName}</Box>
          </Text>
          <Text m="3" fontWeight="bold">
            Document Code: <Box as="span" fontWeight="normal">{eDoc?.DocumentTypeCode}</Box>
          </Text>
        </Flex>

            <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem">
              {/* <EyeIcon style={{cursor:'pointer'}}/> */}
              <EditIcon onClick={()=> handleEdit(eDoc)} style={{cursor:'pointer'}} />
              <DeleteIcon onClick={()=> handleDeleteDocument(eDoc.Id)} style={{cursor:'pointer'}} />
            </Flex>
        </Card>):''}
      </Grid>
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
      
    </Box>
}
    </>
  )
   
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

export default DocumentType;

 
const AddSchema = Yup.object({
  DocumentTypeName:Yup.string().required(),
  DocumentTypeCode:Yup.string().required(),
  ExamSubjectId:Yup.number(),
  LevelId:Yup.number(),
});


const AddType = (props:any) =>{
  // console.log({...props},'data')
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const [uploadedFiles, setUploadedFiles] = useState<any>([]);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setUploadedFiles(acceptedFiles);
    },
  });

  const removeFile=(name:any)=>{
    setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
  }


  const { mutate: addUpdate, isLoading } = useMutation({
    mutationKey: ['new-exam-document-type'],
    mutationFn: async (data: any) => {
      return props && props.Id
        ? await apiCall().put(`/exam/setup/examDocumentType/${props.Id}`, data) 
        : await apiCall().post(`/exam/setup/examDocumentType`, data); 
    },
    onSuccess: (data) => {
      set_notification({
        type: 'success',
        message: data?.data?.Message || 'Added Successfully',
      });
      set_Nopen(true);
      queryClient.invalidateQueries(['exam-document-type']);
      setUploadedFiles([]);
    },
    onError(error: any, variables, context) {
      // Extract specific error message from server response
      let errorMessage = 'Error Occurred';
      if (error?.response?.data?.Message) {
        errorMessage = error.response.data.Message;
      } else if (error.message) {
        errorMessage = error.message; // Handle potential error message directly from the error object
      }
  
      set_notification({
        type: 'error',
        message: errorMessage,
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });
  return (
    <>
      <Formik
          initialValues={{
            DocumentTypeName:props.DocumentTypeName || '',
            DocumentTypeCode:props.DocumentTypeCode || '',
          }}
          validationSchema={AddSchema}
          onSubmit={(values:any) => {
            const data = {
              DocumentTypeName:values.DocumentTypeName,
              DocumentTypeCode:values.DocumentTypeCode,
            };
           // console.log(data,'form data')

            addUpdate(data);

          }}
        >
         {(formik:any)=>{
        const {errors} = formik;
        return (
            <Form>
              <Flex flexDir={"column"} align={"center"} gap="20px">
              <Input as={Field} 
                placeholder="Document Name"
                name="DocumentTypeName"
                type="text"
              />
              <Input as={Field} 
                placeholder="Document Code"
                name="DocumentTypeCode"
                type="text"
              />
                
                <Flex flexDir="column" gap="10px" w="100%">
                  
                  {/* Upload Document:<br/>                   */}
                  {/* <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
                    {uploadedFiles.map((file:any) => (
                      <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
                    ))}
                  </UnorderedList> */}

                  {/* <Box {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Image
                      alt="upload document"
                      src={src}
                      w="100%"
                      h="150px"
                      objectFit="contain"
                      objectPosition="center"
                    />
                  </Box> */}
                </Flex>
                <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                  {isLoading?"Loading":'Submit'}
                </Button>
              </Flex>
                
              
            </Form>
          )}}
        </Formik>
    </>
  )
}